import React from "react";
import { CommunityDetailPage } from "@/components/communities";

export default function CommunityDetail() {
  return <CommunityDetailPage />;
}
